/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './configurator-attribute-not-supported.component';
export * from './configurator-attribute-not-supported.module';
